// src/components/NewsCard/NewsCard.js

import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatNewsDate } from "../../../utils/newsHelpers";
import "./NewsCard.css";

export default function NewsCard({ item, layout = "grid" }) {
  const { i18n, t } = useTranslation();
  const isArabic = i18n.language?.startsWith("ar");

  return (
    <Card className={`news-card news-card--${layout} h-100`}>
      <Link to={`/news/${item.slug}`} className="news-card__image-link">
        <div className="news-card__image-wrap">
          <Card.Img
            variant="top"
            src={item.featuredImage}
            alt={isArabic ? item.featuredAlt.ar : item.featuredAlt.en}
            className="news-card__image"
          />
        </div>
      </Link>

      <Card.Body className="news-card__body">
        <div className="news-card__meta">
          {formatNewsDate(item.date, isArabic)}
        </div>

        <Card.Title className="news-card__title">
          <Link to={`/news/${item.slug}`} className="news-card__title-link">
            {isArabic ? item.title.ar : item.title.en}
          </Link>
        </Card.Title>

        <Card.Text className="news-card__excerpt">
          {isArabic ? item.excerpt.ar : item.excerpt.en}
        </Card.Text>

        <Link to={`/news/${item.slug}`} className="lk-brand-link">
          {t("news.readMore", {
            defaultValue: isArabic ? "اقرأ المزيد" : "Read More",
          })}
        </Link>
      </Card.Body>
    </Card>
  );
}